//@flow
import * as Immutable from 'immutable';
import { Document } from 'common/models/flow/Document';
import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';
import type { DocumentModelType } from 'common/models/flow/Document';
import I18nHelper from 'common/helpers/I18nHelper';
import DataUtils from 'common/utils/DataUtils';

const translationsNamespace = ['entityManagement'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);
@validatable
class InternalDocument extends Document {
    static fromJS(json: DocumentModelType): InternalDocument {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @validate
    setImageUrl(imageUrl: string): this {
        return super.setImageUrl(imageUrl);
    }

    validateImageUrl(): ?string {
        if (this.isMandatory && DataUtils.isEmpty(this.imageUrl)) {
            const { type } = this;
            return nsTranslate('documentUpload.emptyDocument', { type });
        }
    }

    @validate
    setExpiryDate(expiryDate: string): this {
        return super.setExpiryDate(expiryDate);
    }

    validateExpiryDate() {
        if (
            this.isMandatory &&
            this.isExpiryDateApplicable &&
            DataUtils.isEmpty(this.expiryDate)
        ) {
            const { type } = this;
            return nsTranslate('documentUpload.expiryDateEmpty', { type });
        }
    }

    @validate
    setDocumentId(documentId: string): this {
        return super.setDocumentId(documentId);
    }

    validateDocumentId() {
        if (
            this.isMandatory &&
            this.isDocumentIdApplicable &&
            DataUtils.isEmpty(this.documentId)
        ) {
            const { type } = this;
            return nsTranslate('documentUpload.documentIdEmpty', { type });
        }
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    defaultSanitize(): ?this {
        const sanitizedDocument = super.defaultSanitize();
        if (sanitizedDocument) {
            return sanitizedDocument
                .set('isDocumentIdApplicable', null)
                .set('isMandatory', null)
                .set('isExpiryDateApplicable', null)
                .set('isMultiApplicable', null);
        }
    }
}

export { InternalDocument as Document };
